
export default {

    state: {
        devMode: false,
    },

    mutations: {
        active(state) {
            state.devMode = true;
        },
        disable(state) {
            state.devMode = false;
        },
    },

    actions: {
        activeDevMode({ commit }) {
            commit('active');
        },
        disableDevMode({ commit }) {
            commit('disable');
        },
    },

    getters: {
        devMode: state => state.devMode,
    },
};
